<template>
  <section>
    <section class="calc-box-container">
      <!-- 左侧 -->
      <div class="calc-box-left">
        <div class="text-box">
          <div class="main-text">
            <div class="label">
              {{
              isExternalFreight
              ? '外调车运费'
              : '承包价'
              }}
            </div>
            <div class="value color-normal">
              <div>{{ orderData.orderFee.totalFee / 100 }}</div>
              <div
                class="error"
                v-if="orderData.orderFeeVer && orderData.orderFeeVer.totalFee && (orderData.orderFee.totalFee !== orderData.orderFeeVer.totalFee)"
              >{{ orderData.orderFeeVer.totalFee / 100 }}</div>
            </div>
          </div>
        </div>
        <div
          class="text-box"
          v-if="isExternalFreight"
        >
          <div class="main-text">
            <div class="label">运费上限</div>
            <div
              class="value color-normal"
            >{{ orderData.orderFee ? orderData.orderFee.guidePrice / 100 : 0 }}</div>
          </div>
        </div>
      </div>
      <!-- 间隔线 -->
      <div class="calc-box-separate"></div>
      <!-- 右侧 -->
      <div class="calc-box-right">
        <div class="calc-row">
          <div class="row-label">预付金额</div>
          <div class="row-content">
            <div class="row-box-item">
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">现付：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee
                      ? orderData.orderFee.preTotalFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.preTotalFee !== orderData.orderFeeVer.preTotalFee)"
                  >
                    <span>现付：</span>
                    <span>
                      {{
                      orderData.orderFeeVer
                      ? orderData.orderFeeVer.preTotalFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row-symbol">=</div>
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">现金：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee ? orderData.orderFee.preCashFee / 100 : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.preCashFee !== orderData.orderFeeVer.preCashFee)"
                  >
                    <span>现付：</span>
                    <span>
                      {{
                      orderData.orderFeeVer
                      ? orderData.orderFeeVer.preCashFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row-symbol">+</div>
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">虚拟油卡：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee
                      ? orderData.orderFee.preOilVirtualFee / 100
                      : 0
                      }}
                    </span>
                  </div>

                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.preOilVirtualFee !== orderData.orderFeeVer.preOilVirtualFee)"
                  >
                    <span>虚拟油卡：</span>
                    <span>
                      {{
                      orderData.orderFeeVer ? orderData.orderFeeVer.preOilVirtualFee / 100 : 0}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row-symbol">+</div>
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">油卡：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee ? orderData.orderFee.preOilFee / 100 : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.preOilFee !== orderData.orderFeeVer.preOilFee)"
                  >
                    <span>油卡：</span>
                    <span>
                      {{
                      orderData.orderFeeVer ? orderData.orderFeeVer.preOilFee / 100 : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <template
                v-show="
                dispatchInfo.preEtcFee > 0 ||
                isContractPaymentWay
              "
              >
                <div class="row-symbol">+</div>
                <div class="row-box">
                  <div class="text-box">
                    <div>
                      <span class="label">ETC：</span>
                      <span class="value color-normal">
                        {{
                        orderData.orderFee
                        ? orderData.orderFee.preEtcFee / 100
                        : 0
                        }}
                      </span>
                    </div>
                    <div
                      class="error"
                      v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.preEtcFee !== orderData.orderFeeVer.preEtcFee)"
                    >
                      <span>ETC：</span>
                      <span>
                        {{
                        orderData.orderFeeVer
                        ? orderData.orderFeeVer.preEtcFee / 100
                        : 0
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div
          class="calc-row"
          :style="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.arrivePaymentFee !==orderData.orderFeeVer.arrivePaymentFee) ? 'padding: 8px 0;' : ''"
        >
          <div class="row-label">到付金额</div>
          <div class="row-content">
            <div class="row-box-item">
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">总计：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee
                      ? orderData.orderFee.arrivePaymentFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.arrivePaymentFee !==orderData.orderFeeVer.arrivePaymentFee)"
                  >
                    <span>总计：</span>
                    <span>
                      {{
                      orderData.orderFeeVer
                      ? orderData.orderFeeVer.arrivePaymentFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">尾款金额</div>
          <div class="row-content">
            <div class="row-box-item">
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">总计：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee ? orderData.orderFee.finalFee / 100 : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.finalFee !==orderData.orderFeeVer.finalFee)"
                  >
                    <span>总计：</span>
                    <span>
                      {{
                      orderData.orderFeeVer ? orderData.orderFeeVer.finalFee / 100 : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row-symbol">=</div>
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">现金：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee
                      ? (orderData.orderFee.finalFee -
                      orderData.orderFee.insuranceFee) /
                      100
                      : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && ((orderData.orderFee.finalFee -
                      orderData.orderFee.insuranceFee) !== ((orderData.orderFeeVer.finalFee -
                      orderData.orderFeeVer.insuranceFee)))"
                  >
                    <span class="label">现金：</span>
                    <span class="value">
                      {{
                      orderData.orderFeeVer
                      ? (orderData.orderFeeVer.finalFee -
                      orderData.orderFeeVer.insuranceFee) /
                      100
                      : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row-symbol">+</div>
              <div class="row-box">
                <div class="text-box">
                  <div>
                    <span class="label">保费：</span>
                    <span class="value color-normal">
                      {{
                      orderData.orderFee
                      ? orderData.orderFee.insuranceFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                  <div
                    class="error"
                    v-if="(orderData.orderFee && orderData.orderFeeVer) && (orderData.orderFee.insuranceFee !==orderData.orderFeeVer.insuranceFee)"
                  >
                    <span class="label">保费：</span>
                    <span class="value">
                      {{
                      orderData.orderFeeVer
                      ? orderData.orderFeeVer.insuranceFee / 100
                      : 0
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="calc-other-info">
<!--      <div-->
<!--        class="other-info-box"-->
<!--        v-if="-->
<!--          orderData.orderFee.preOilVirtualFee > 0 ||-->
<!--          orderData.orderFee.oilSelfVirtual > 0-->
<!--        "-->
<!--      >-->
        <div class="other-info-box">
        <div class="other-info-item">
          <span>分配油来源：</span>
          <span
            v-if="
              orderData.orderFee.preOilVirtualFee > 0 ||
              orderData.orderFee.oilSelfVirtual > 0
            "
          >
            {{
            orderData.orderFeeExt.oilConsumer === 1
            ? '本车队定点油'
            : orderData.orderFeeExt.oilConsumer === 2 &&
            orderData.orderFeeExt.oilAccountType === 2
            ? '找油-无发票'
            : orderData.orderFeeExt.oilConsumer === 2 &&
            orderData.orderFeeExt.oilAccountType === 3
            ? '找油-有发票'
            : orderData.orderFeeExt.oilConsumer === 3 &&
            orderData.orderFeeExt.oilAccountType === 2
            ? '万金油-无发票'
            : orderData.orderFeeExt.oilConsumer === 3 &&
            orderData.orderFeeExt.oilAccountType === 3
            ? '万金油-有发票'
            : ''
            }}
          </span>
        </div>
          <div class="other-info-item">
              <span>司机是否可见服务费：</span>
              <span class="value">
                {{orderData.orderInfoExt.showWagesFlg===1?'是':'否'}}
            </span>
              <span
                  class="error-info error"
                  v-if="
                orderData &&
                orderData.orderInfoExtVer &&
                orderData.orderInfoExt.showWagesFlg !==
                  orderData.orderInfoExtVer.showWagesFlg
              "
              >修改为：{{orderData.orderInfoExtVer.showWagesFlg===1?'是':'否' }}</span>
          </div>
        <div class="other-info-item">
          <span>税点和操作费用：</span>
          <span class="value">
                      {{displayField(orderData.orderInfoExt, ['taxPointDouble', 'TAXPOINTDOUBLE', 'taxPoint'])}} %
          </span>
          <span
              class="error-info error"
              v-if="
              orderData &&
              orderData.orderInfoExtVer &&
              fieldValue(orderData.orderInfoExt, ['taxPointDouble', 'TAXPOINTDOUBLE', 'taxPoint']) !==
                fieldValue(orderData.orderInfoExtVer, ['taxPointDouble', 'TAXPOINTDOUBLE', 'taxPoint'])
            "
          >修改为：{{
              displayField(orderData.orderInfoExtVer, ['taxPointDouble', 'TAXPOINTDOUBLE', 'taxPoint'])
            }} %</span
          >
        </div>
        <div class="other-info-item">
          <span>其他费用：</span>
          <span class="value">
                      {{displayField(orderData.orderInfoExt, ['otherFeeDouble', 'OTHERFEEDOUBLE', 'otherFee'])}} 元
          </span>
          <span
              class="error-info error"
              v-if="
              orderData &&
              orderData.orderInfoExtVer &&
              fieldValue(orderData.orderInfoExt, ['otherFeeDouble', 'OTHERFEEDOUBLE', 'otherFee']) !==
                fieldValue(orderData.orderInfoExtVer, ['otherFeeDouble', 'OTHERFEEDOUBLE', 'otherFee'])
            "
          >修改为：{{
              displayField(orderData.orderInfoExtVer, ['otherFeeDouble', 'OTHERFEEDOUBLE', 'otherFee'])
            }} 元</span
          >
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      default: () => ({
        orderScheduler: {},
        orderFee: {},
        orderFeeExt: {},
        orderInfoExt: {},
        orderInfoExtVer: {},
      }),
    },
  },
  data () {
    return {
      dispatchInfo: {},
    };
  },
  computed: {
    isExternalFreight () {
      const scheduler = this.orderData.orderScheduler || {};
      return (Number(scheduler.appointWay) === 3 && Number(scheduler.vehicleClass) !== 1) || Number(scheduler.appointWay) === 5;
    },
    isContractPaymentWay () {
      const scheduler = this.orderData.orderScheduler || {};
      return Number(scheduler.appointWay) === 3 && Number(scheduler.vehicleClass) === 1 && Number(this.dispatchInfo.paymentWay) === 3;
    },
  },
  methods: {
    fieldValue (data, fields) {
      const source = data || {};
      for (let field of fields) {
        if (source[field] !== undefined && source[field] !== null && source[field] !== '') {
          return source[field];
        }
      }
      return '';
    },
    displayField (data, fields) {
      const value = this.fieldValue(data, fields);
      return value === '' ? '--' : value;
    },
  },
};
</script>

<style lang="scss" scoped>
.color-normal {
  color: #0088ff;
}
.row-symbol-hide {
  opacity: 0;
}
.calc-box-container {
  display: flex;
  align-items: center;
  margin: 10px 0;
  position: relative;
  .text-box {
    font-size: 14px;
    border-radius: 2px;
    border-radius: 2px;
    display: flex;
    &:nth-of-type(2) {
      padding-top: 5px;
    }
    .label {
      color: #333333;
    }
  }

  .calc-box-left {
    padding: 5px 0px;
    .text-box {
      display: flex;
      flex-direction: column;
      .main-text {
        display: flex;
      }
      .label {
        line-height: 20px;
        word-break: keep-all;
        width: 90px;
      }
      .value {
        // color: #ff5046;
        line-height: 20px;
      }
    }
  }
  .calc-box-separate {
    width: 9px;
    height: 68%;
    margin-left: 26px;
    position: absolute;
    left: 120px;
    top: 15%;
    border: 1px solid #ededed;
    border-right: none;
    &:before {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 7.5px solid transparent;
      border-right: 8px rgba(224, 233, 243, 1) solid;
      border-bottom: 7.5px solid transparent;
      top: 50%;
      left: -8px;
      margin-top: -7.5px;
    }
    &:after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 9px #fff solid;
      border-bottom: 6px solid transparent;
      top: 50%;
      left: -7px;
      z-index: 2;
      margin-top: -7.5px;
    }
  }
  .calc-box-right {
    display: flex;
    flex-direction: column;
    margin-left: 44px;
    .row-title {
      margin-bottom: 14px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      :first-child {
        width: 174px;
      }
      :nth-last-child(1) {
        width: 180px;
        text-align: right;
      }
      :nth-last-child(2) {
        width: 300px;
        text-align: center;
      }
    }
    .calc-row {
      display: flex;
      flex-direction: row;
      // align-items: center;
      &:nth-of-type(2) {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
      .row-label {
        margin: 0 20px 0 12px;
        word-break: keep-all;
      }
      .row-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .row-box-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          line-height: 1.5;
          .row-box {
            // width: 120px;
            .text-box {
              display: flex;
              flex-direction: column;
              &:only-child {
                box-sizing: border-box;
              }
              &:nth-of-type(2) {
                margin-top: -1px;
              }
              .label {
                word-break: keep-all;
              }
            }
          }
          .row-symbol {
            font-size: 14px;
            color: #bcbbbb;
            margin: 0 14px;
          }
        }
      }
    }
  }
}
.calc-other-info {
  .other-info-box {
    display: flex;
    .other-info-item {
      margin-right: 40px;
    }
  }
}
</style>
